<template>
    <div id="newGoodMainPicture" class="main-picture" style="position: relative;">
        <div style="position: absolute; left:0px;top:0px;" class="main-picture">
            <img class="main-bg"
                src="https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/enterprisePromo/share-img.jpg"
                alt="">
            <div>
                <div class="main-title">海尔家电内购会</div>
                <div class="desc">员工专享，璀璨开启，精选商品，尊享超低折扣，不容错过！</div>
            </div>
            <div class="main-footer">
                <div class="footer-flex">
                    <div class="flex-img">
                        <img :src="canvasSrc" alt="">
                    </div>
                    <div class="flex-info">
                        <p>微信扫一扫参与活动</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<style lang="scss" scoped>
.main-picture {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    width: 261px;
    height: 485px;
    font-size: 0.32rem;
    background: #FFFFFF;
    border-radius: 12px;
    border: none;
    .main-bg {
      width: 264px;
      height: 264px;
      position: relative;
      left: -1px;
      top: -1px;
    }
    .main-title {
        margin-top: 12px;
        font-size: 16px;
        color: #2C3E50;
        letter-spacing: 0;
        line-height: 20px;
        font-weight: bold;
        padding: 0 24px;
    }

    .desc {
        font-size: 12px;
        color: #416180;
        letter-spacing: 0;
        line-height: 16px;
        font-weight: 400;
        padding: 0 24px;
        margin-top: 6px;
    }

    .flex-img {
        width: 100px;
        height: 100px;
        margin-top: 12px;
        overflow: hidden;
        // border-radius: 50px;

        img {
            width: 100px;
            height: 100px;
        }
    }

    .flex-info {
        margin-top: 16px;
        font-size: 10px;
        color: #999999;
        letter-spacing: 0;
        line-height: 9px;
        font-weight: 400;
        text-align: center;
    }
}
</style>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import personalApi from '@/http/service/index'
import html2canvas from 'html2canvas'
import { getClientSunCode } from '@/http/service/common'

export default {
  name: 'enterprisePicture',
  data() {
    return {
      canvasSrc: '',
    }
  },
  async mounted() {
    this.$toast.loading({
      forbidClick: true,
      message: '加载中...',
      duration: 0
    })
    await Promise.all([
      this.getShopQrCode()
    ]).then(() => {
      console.log('all end==============>')
      this.$nextTick(async () => {
        try {
          let imgUrl = await this._html2canvas()
          // this.$util.logColor('imgUrl', 'green', imgUrl)
          this.setShareWxTMImgBase64(imgUrl)
          this.$emit('picFinish')
          this.$toast.clear()
        } catch (error) {
          this.$util.logColor('canvashtml', 'green', error)
          this.$toast.clear()
        }
      })
    }).catch(e => {
      console.log('all catch')
      this.$toast.clear()
    })
  },
  methods: {
    ...mapMutations('common', ['setShareWxTMImgBase64']),
    async getShopQrCode() {
      const query = {}
      let originUrl = window.location.href + `&custom_title=海尔家电内购会&needShare=1&needLocation=1&needLogin=1`
      let defaultIMG = 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/enterprisePromo/wx-card.jpg?x-oss-process=image/format,webp'
      const appInfo = await this.$util.getAppInfo()
      const { data } = await getClientSunCode({
        appId: "wxe24b2f1f4e378891", //智家APP小程序
        scene: `src=${encodeURIComponent(originUrl)}`,
        page: "pages/webView/webViewNew",
        envVersion: this.$util.isProdEnv() ? "release" : 'trial',
        // envVersion: 'release',
        qrWidth: 500
      }, {
        appId: appInfo?.appId || '',
        appVersion: appInfo?.appVersion || '',
        clientId: appInfo?.clientId || '',
        timestamp: new Date().getTime(),
        accountToken: this.accessToken
      })
      console.log('genreateQr========222=======>', data)
      if (data.retCode === '00000') {
        this.canvasSrc = data.data.data
      } else {
        this.$toast('获取信息码失败')
      }
      return Promise.resolve(true)

    },

    shareContent() {
      return document.getElementById(`newGoodMainPicture`)
    },
    _getPixelRatio(context) {
      var backingStore =
                context.backingStorePixelRatio ||
                context.webkitBackingStorePixelRatio ||
                context.mozBackingStorePixelRatio ||
                context.msBackingStorePixelRatio ||
                context.oBackingStorePixelRatio ||
                context.backingStorePixelRatio ||
                1
      return (window.devicePixelRatio || 1) / backingStore
    },
    _html2canvas() {
      return new Promise((resolve, reject) => {
        // 创建一个新的canvas
        const _canvas = this.shareContent()
        this.$util.logColor('_canvas', 'blue', _canvas)
        // 此处用于解决截图不清晰问题，将生成的canvas放大，然后再填充到原有的容器中就会清晰
        const width = _canvas.offsetWidth
        const height = _canvas.offsetHeight
        const canvas2 = document.createElement('canvas')
        const ctx = canvas2.getContext('2d')
        const ratio = this._getPixelRatio(ctx)
        const scale = ratio
        canvas2.width = width * scale
        canvas2.height = height * scale
        ctx.scale(scale, scale)
        const opts = {
          scale: 1,
          canvas: canvas2,
          logging: true, // 日志开关，便于查看html2canvas的内部执行流程
          width,
          height,
          allowTaint: true,
          useCORS: true, // 【重要】开启跨域配置
        }
        html2canvas(_canvas, opts).then(async canvas => {
          const context = canvas.getContext('2d')
          // 【重要】关闭抗锯齿
          context.mozImageSmoothingEnabled = false
          context.webkitImageSmoothingEnabled = false
          context.msImageSmoothingEnabled = false
          context.imageSmoothingEnabled = false

          const screenUrl = canvas.toDataURL('image/png')
          console.log('screenUrl', screenUrl)
          resolve(screenUrl)
        }).catch(e => { console.log(e) });
      })
    },
  }
}
</script>
